import { shot_type, $Enums } from '@acme/db';

type ModifierObject = {
  id: string;
  name: string;
  type: string;
  enabled: boolean;
  strength?: number;
  verified?: boolean;
  categories?: any[];
  data?: string;
  weight?: string;
};

export const parseShotType = (modifiers: ModifierObject[] | undefined): shot_type | null => {
  console.log('Parsing shot type from modifiers:', modifiers);

  if (!modifiers) {
    console.log('Modifiers is undefined or null');
    return null;
  }

  const shotTypeModifier = modifiers.find(
    modifier => modifier.type === 'modifier' && modifier.enabled && /{shot[_]?[tT]ype(:.*)?}/.test(modifier.name)
  );

  if (!shotTypeModifier) {
    console.log('No shot_type modifier found');
    return null;
  }

  console.log('Found shot type modifier:', shotTypeModifier.name);

  const match = shotTypeModifier.name.match(/{shot_type:?([\w-]+)?}/);

  if (!match) {
    console.log('Invalid shot_type format');
    return null;
  }

  if (!match[1]) {
    console.log('Generic {shot_type} found, no specific type');
    return null; // Return null to indicate no specific filtering
  }

  const specifiedType = match[1].toLowerCase();
  console.log('Specified shot type:', specifiedType);

  switch (specifiedType) {
    case 'wide shot':
    case 'wide_shot':
    case 'wide-shot':
      return $Enums.shot_type.wide_shot;
    case 'closeup':
    case 'close-up':
    case 'close_up':
      return $Enums.shot_type.closeup;
    case 'headshot':
    case 'head shot':
    case 'head_shot':
    case 'head-shot':
      return $Enums.shot_type.headshot;
    default:
      console.log('Unknown shot type specified:', specifiedType);
      return null;
  }
};
